/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_HarvestingInputs */

const vi_care_log_activity_harvesting = /** @type {(inputs: Care_Log_Activity_HarvestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hái chè`)
};

/**

* @param {Care_Log_Activity_HarvestingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_harvesting = /** @type {((inputs?: Care_Log_Activity_HarvestingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_HarvestingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_harvesting(inputs)
});